// userLocationMapping.js - User location utility functions
// NOTE: User locations are now stored in database (tblUsers.UserLocation)
// and loaded into localStorage at login. This file contains utility functions only.

/**
 * Gets the current user's location from session/localStorage
 * @returns {string} The user's location
 */
export const getUserLocation = () => {
  try {
    const userData = JSON.parse(localStorage.getItem('user') || '{}');
    return userData.UserLocation || 'Pomona';
  } catch (error) {
    console.error('Error getting user location:', error);
    return 'Pomona';
  }
};

/**
 * Maps user location to warehouse name for database storage
 * @param {string} location - The user's location
 * @returns {string} The warehouse name for database
 */
export const getWarehouseFromLocation = (location) => {
  if (!location) return 'Pomona';

  const locationUpper = location.toUpperCase().trim();

  switch (locationUpper) {
    case 'POMONA':
    case 'NY':
    case 'NEW YORK':
      return 'Pomona';
    case 'LAKEWOOD':
    case 'NJ':
    case 'NEW JERSEY':
      return 'Lakewood';
    case 'ISRAEL':
    case 'IL':
      return 'Israel';
    default:
      console.warn(`Unknown location: ${location}, defaulting to Pomona`);
      return 'Pomona';
  }
};

/**
 * Gets the warehouse for the current user from session
 * @returns {string} The warehouse name for the current user
 */
export const getCurrentUserWarehouse = () => {
  try {
    const userLocation = getUserLocation();
    const warehouse = getWarehouseFromLocation(userLocation);

    console.log(`🏢 Location: ${userLocation} → Warehouse: ${warehouse}`);
    return warehouse;
  } catch (error) {
    console.error('Error determining user warehouse:', error);
    return 'Pomona'; // Safe fallback
  }
};

/**
 * Gets user-friendly location display name
 * @param {string} location - The location to get display name for
 * @returns {string} Display name for location
 */
export const getLocationDisplayName = (location) => {
  if (!location) return 'Unknown Location';

  const locationUpper = location.toUpperCase().trim();

  switch (locationUpper) {
    case 'POMONA':
    case 'NY':
    case 'NEW YORK':
      return 'New York/Pomona';
    case 'LAKEWOOD':
    case 'NJ':
    case 'NEW JERSEY':
      return 'New Jersey/Lakewood';
    case 'ISRAEL':
    case 'IL':
      return 'Israel';
    default:
      return location || 'Unknown Location';
  }
};

export default {
  getUserLocation,
  getWarehouseFromLocation,
  getCurrentUserWarehouse,
  getLocationDisplayName
};
